import React, { useState, useRef, useEffect } from "react";
import {
  Icon,
  Label,
  Segment,
  Header,
  Divider,
  Message,
  Transition,
  Button,
} from "semantic-ui-react";
import { Link, useNavigate } from "react-router-dom";
import { Notification } from "../../../api"; // Importa el controlador de notificaciones
import { useAuth } from "../../../hooks"; // Importa el controlador de notificaciones
import moment from "moment";
import "moment/locale/es"; // Importa el idioma español
import "./NotificationBell.scss";

const notificationController = new Notification();

moment.locale("es"); // Configura moment para usar el idioma español

export function NotificationBell(props) {
  const {
    notifications,
    unreadCount,
    onReloadNotifications,
    notificationsPath = "/student/myNotifications",
    postBasePath = "/student/post",
  } = props;
  const navigate = useNavigate();
  const { accessToken, user } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const [animation, setAnimation] = useState(false);
  const notificationRef = useRef(null);

  useEffect(() => {
    // Cerrar el panel de notificaciones al hacer clic fuera de él
    function handleClickOutside(event) {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleNotifications = () => {
    setIsOpen(!isOpen);
  };

  const markAsRead = async (id) => {
    await notificationController.updateNotification(id, {
      viewed: true,
    });
    onReloadNotifications();
    setIsOpen(false);
  };

  const markAsReadAll = async () => {
    await notificationController.readAllNotifications(user.id);
    onReloadNotifications();
    setIsOpen(false);
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case "high":
        return "red";
      case "medium":
        return "yellow";
      case "low":
        return "green";
      default:
        return "grey";
    }
  };

  return (
    <div className="notification-bell-container" ref={notificationRef}>
      <div className="notification-bell" onClick={toggleNotifications}>
        <Icon
          name="bell"
          size="large"
          className={animation && unreadCount > 0 ? "bell-animation" : ""}
        />
        {unreadCount > 0 && (
          <Label circular color="red" floating size="mini">
            {unreadCount}
          </Label>
        )}
      </div>

      <Transition visible={isOpen} animation="slide down" duration={200}>
        <div className="notification-panel">
          <Segment raised>
            <div className="notification-panel-header">
              <Header as="h4">
                <Icon name="bell" />
                <Header.Content>
                  Notificaciones
                  <Header.Subheader>{unreadCount} sin leer</Header.Subheader>
                </Header.Content>
              </Header>
              <div className="notification-panel-actions">
                {notifications.length > 0 && (
                  <Button
                    as={"a"}
                    className="ui circular icon button green tiny"
                    onClick={() => markAsReadAll()}
                    // disabled={unreadCount === 0}
                    title="Marcar todas como leídas"
                  >
                    <Icon name="check" />
                  </Button>
                )}
                <Button
                  as={Link}
                  to={notificationsPath}
                  className="ui circular icon button blue tiny"
                  title="Ver todas las notificaciones"
                  onClick={() => setIsOpen(false)}
                >
                  <Icon name="arrow right" />
                </Button>
              </div>
            </div>
            <Divider className="notification-divider" />

            <div className="notification-list">
              {notifications.length === 0 ? (
                <p>Cuando recibas notificaciones, aparecerán aquí.</p>
              ) : (
                notifications.map((notification) => (
                  <Segment
                    key={notification.id}
                    className={`notification-div ${
                      notification.viewed
                        ? "notification-read"
                        : "notification-unread"
                    }`}
                    raised={!notification.viewed}
                  >
                    <div className="notification-header">
                      <div className="notification-title">
                        <Label
                          color={getPriorityColor(notification.priority)}
                          size="tiny"
                          circular
                          empty
                          className="priority-indicator"
                        />
                        <span>{notification.title}</span>
                      </div>
                      <Label size="tiny" className="notification-date">
                        {moment.utc(notification.createdAt).local().fromNow()}
                      </Label>
                    </div>
                    <div className="notification-content">
                      <div className="notification-message">
                        {notification.message}
                      </div>
                      <div className="notification-actions">
                        <Button
                          as={"a"}
                          className="ui circular icon button green tiny"
                          onClick={() => markAsRead(notification.id)}
                          disabled={notification.viewed}
                          title="Marcar como leído"
                        >
                          <Icon name="check" />
                        </Button>
                        {notification.postId && (
                          <Button
                            as={Link}
                            to={`${postBasePath}/${notification.postId}`}
                            className="ui circular icon button blue tiny"
                            title="Ver post"
                            onClick={() => setIsOpen(false)}
                          >
                            <Icon name="arrow right" />
                          </Button>
                        )}
                      </div>
                    </div>
                  </Segment>
                ))
              )}
            </div>
          </Segment>
        </div>
      </Transition>
    </div>
  );
}
